/**
 * Currency-specific minimum charge amounts from Stripe
 * @see https://docs.stripe.com/currencies#minimum-and-maximum-charge-amounts
 */
export const STRIPE_MINIMUM_AMOUNTS: Record<string, number> = {
  USD: 0.5,
  AED: 2.0,
  AUD: 0.5,
  BGN: 1.0,
  BRL: 0.5,
  CAD: 0.5,
  CHF: 0.5,
  CZK: 15.0,
  DKK: 2.5,
  EUR: 0.5,
  GBP: 0.3,
  HKD: 4.0,
  HUF: 175.0,
  INR: 0.5,
  JPY: 50,
  MXN: 10.0,
  MYR: 2.0,
  NOK: 3.0,
  NZD: 0.5,
  PLN: 2.0,
  RON: 2.0,
  SEK: 3.0,
  SGD: 0.5,
  THB: 10.0,
}

/** Default minimum amount (USD) used as fallback */
const DEFAULT_MINIMUM_AMOUNT = 0.5

interface Outlet {
  currency?: string
  currency_symbol?: string
}

interface LsPayMinimumInfo {
  minimumAmount: number
  currencySymbol: string
  currencyCode: string | undefined
}

/**
 * Get the minimum LSPay amount and currency info for a given outlet
 * @param outlet - The outlet object containing currency and currency_symbol
 * @returns Object with minimumAmount, currencySymbol, and currencyCode
 */
export function getMinimumLsPayAmount(outlet?: Outlet): LsPayMinimumInfo {
  const currencyCode = outlet?.currency
  const currencySymbol = outlet?.currency_symbol ?? '$'

  const minimumAmount = currencyCode
    ? STRIPE_MINIMUM_AMOUNTS[currencyCode.toUpperCase()] ??
      DEFAULT_MINIMUM_AMOUNT
    : DEFAULT_MINIMUM_AMOUNT

  return {
    minimumAmount,
    currencySymbol,
    currencyCode,
  }
}
